import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const purchasePaymentService = {
  async getPurchasePayments(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/purchase-payment-master", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getPaymentsByPurchaseMasterId(pmId) {
    if (!pmId) throw new Error("Purchase Master ID is required");
    try {
      const response = await apiClient.get(`/purchase-payment-master/purchase/${pmId}`);
      const payload = response?.data || {};
      const data = extractData(payload);
      return toArray(data);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getPurchasePaymentById(id) {
    if (!id) throw new Error("Payment Transaction ID is required");
    try {
      const response = await apiClient.get(`/purchase-payment-master/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createPurchasePayment(payload) {
    try {
      let data = payload;
      let headers = {};
      if (payload.attachment) {
        data = new FormData();
        Object.keys(payload).forEach((key) => {
          if (payload[key] !== null && payload[key] !== undefined) {
            data.append(key, payload[key]);
          }
        });
        headers = { "Content-Type": "multipart/form-data" };
      }
      const response = await apiClient.post("/purchase-payment-master", data, { headers });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updatePurchasePayment(id, payload) {
    if (!id) throw new Error("Payment Transaction ID is required");
    try {
      let data = payload;
      let headers = {};
      if (payload.attachment) {
        data = new FormData();
        Object.keys(payload).forEach((key) => {
          if (payload[key] !== null && payload[key] !== undefined) {
            data.append(key, payload[key]);
          }
        });
        headers = { "Content-Type": "multipart/form-data" };
      }
      const response = await apiClient.patch(`/purchase-payment-master/${id}`, data, { headers });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deletePurchasePayment(id) {
    if (!id) throw new Error("Payment Transaction ID is required");
    try {
      const response = await apiClient.delete(`/purchase-payment-master/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default purchasePaymentService;
